export const globalCheckboxPreset = {
  acceptTerms: "accept_terms",
} as const

export type GlobalCheckboxPreset = (typeof globalCheckboxPreset)[keyof typeof globalCheckboxPreset]
